import { render, staticRenderFns } from "./PlotCreate.vue?vue&type=template&id=38337e3c"
import script from "./PlotCreate.vue?vue&type=script&lang=js"
export * from "./PlotCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports